var exports = {
  "an": "ErrorFallback.module__errorFallbackContainer___YTNZZn",
  "MU": "ErrorFallback.module__errorFallbackIcon___YTNZZn",
  "S6": "ErrorFallback.module__errorFallbackContent___YTNZZn",
  "jQ": "ErrorFallback.module__errorFallbackTitle___YTNZZn",
  "Xu": "ErrorFallback.module__errorFallbackSubtitle___YTNZZn",
  "Xq": "ErrorFallback.module__errorFallbackAccounts___YTNZZn",
  "pF": "ErrorFallback.module__errorFallbackDescription___YTNZZn",
  "sM": "ErrorFallback.module__errorFallbackActions___YTNZZn",
};

module.exports = exports;
